<template>
  <modal
    name="disneyAgree"
    role="dialog"
    aria-labelledby="dialog-title"
    aria-describedby="dialog-content"
    class="m-full"
    :width="700"
    :height="740"
    :maxHeight="800"
    :scrollable="true"
    @before-close="beforeClose"
  >
    <div class="dialog__inner">
      <div class="popup-header">
        <h1 id="dialog-title" tabindex="0">디즈니+ 월정액 가입신청 동의</h1>
        <button
          type="button"
          class="btn_popup_close"
          data-dismiss="modal"
          title="팝업닫기"
          @click="closeDialog"
        >
          <span>팝업 닫기</span>
        </button>
      </div>
      <div id="dialog-content" class="dialog__content mt0">
        <div class="section">
          <div class="section-header blind">
            <h3>디즈니+ 월정액 가입신청 동의(필수)</h3>
          </div>
          <div class="section-body mt0">
             <dl class="field-group vertical mt0">
              <dt class="field-label">
                <h4 role="heading" tabindex="0">상품 내용</h4>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub text-detail scrollable">
                  <p role="region" tabindex="0" class="td-term">
                    [서비스 내용]<br />
    디즈니+ 월정액 서비스에 가입한 고객은 IPTV, 모바일 앱 등을 통하여 월트디즈니 컴퍼니 코리아 유한책임회사(이하, 디즈니)가 제공하는 디즈니+의 콘텐츠를 이용할 수 있습니다. 서비스의 이용요금은 LG유플러스가 고객에게 발송하는 요금 청구서에 포함되어 청구되며, 쿠폰 혜택으로 가입하는 고객의 경우, 이용권 기간 만료 익일에 월정액 요금이 요금 청구서에 포함되어 자동으로 청구됩니다.
    <br /><br />
    [가입대상]<br />
    LG유플러스 IPTV 서비스 또는 5G/LTE 서비스에 가입한 고객 (단, 디즈니+ 회원가입 및 구독은 19세 이상만 가능)
    <br /><br />
    [이용요금]<br />
    월 9,900원(부가세 포함)
    <br /><br />
    [이용약관 주요사항]<br />
    LG U+ 를 통한 디즈니+ 서비스 가입 시 LG U+ 의 디즈니+ 구독 이용약관이 우선 적용됩니다.<br /><br />
    
    ㅇ 본 상품은 월정액 요금제이나, 디즈니의 정책에 따라 시청 콘텐츠별 추가 요금이 부과될 수 있습니다.<br />
    ㅇ 본 상품 구매는 계속/반복적인 서비스에 대한 구매를 포함하며, 이용자가 서비스 해지 신청을 하지 않는 이상 이용자의 최초 구매일을 기준으로 요금은 매월 자동 청구됩니다.<br />
    ㅇ U+ 가 제공하는 쿠폰 혜택으로 가입하는 고객의 경우, 서비스를 해지하지 않는 이상 이용권 만료 익일부터 월정액 요금이 요금 청구서에 포함되어 자동으로 청구됩니다.<br />
    ㅇ 본 상품 가입시부터 디즈니+ 서비스 이용이 시작되며, 디즈니+ 콘텐츠 시청을 위해서는 반드시 본 상품 구매 시 U+ 가 제공하는 안내에 따라 디즈니+ 계정(아이디 및 비밀번호)을 생성 또는 등록을 완료해야 합니다.<br />
    ㅇ 본 상품 해지 신청 시 그 효력은 해당 결제 주기나 무료 이용 기간 종료 시 발생합니다. 해지 신청일부터 결제 주기나 무료 이용 기간 종료 시점까지의 잔여 이용 기간에 대해 환불을 받을 수 없으며, 이용자는 잔여 이용 기간 동안 디즈니+ 서비스를 계속 이용할 수 있습니다.<br />
    ㅇ 본 상품 구매일로부터 7일 이내에 구독을 철회할 수 있습니다.<br />
    ㅇ 디즈니+ 회원가입 및 구독은 19세 이상만 가능하며, 디즈니+ 서비스 이용을 위해서는 회원가입 및 구독 시 디즈니+ 이용약관, 개인정보 수집이용 및 기타 정책에 동의해야 합니다.<br />
    <br />
        당사의 홈페이지(www.lguplus.com)를 통해 LG U+ 디즈니+ 구독 이용약관 전문확인 및 상세한 이용안내를 받을 수 있으며, 본 약관에서 정하지 않은 디즈니+ 서비스 이용에 관한 사항은 디즈니가 제공하는 디즈니+ 이용 약관(https://www.disneyplus.com/legal/subscriber-agreement)에 따릅니다.
                  </p>
                </div>
              </dd>
              <dd class="field-control">
                <ul class="notice-text-list">
                    <li class="notice-text">
                        본인은 LG유플러스를 통한 디즈니+ 월정액 서비스의 상기와 같은 상품내용과 관련하여 동의합니다.
                    </li>
                    <li class="input-container">    
                        <input
                                id="agreement-disney-pop-confirm"
                                v-model="disneyPopAgrYn"
                                type="checkbox"
                                name="agreement-disney-pop-confirm"
                                class="input-checkbox input-text"
                                title=""
                                ref="ref_disneyPopConfirm"/>
                        <label for="agreement-disney-pop-confirm" class="input-label">
                            <em class="primary-text">동의(필수)</em>
                        </label>
                    </li>
                   </ul>
              </dd>
            </dl>
            <dl class="field-group vertical p0">
              <dt class="field-label">
                <h4 role="heading" tabindex="0">개인정보 3자 제공에 대한 동의</h4>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub text-detail scrollable">
                  <p role="region" tabindex="0" class="td-term">
                      ㅇ 제공하는 항목 : 가입번호, 서비스 가입 및 해지 현황<br />
ㅇ 제공받는 자 : 월트 디즈니 컴퍼니 코리아 유한책임회사<br />
ㅇ 이용 목적 : 디즈니+ 서비스 제공 및 정산 등과 관련된 업무<br />
ㅇ 보유 및 이용기간 : 구독 취소 내지 해지시까지 또는 관련 법규에 따라 보유<br />
* 고객은 거부할 권리가 있으며, 동의 거부 시 U+ 를 통한 디즈니+ 가입이 불가합니다.
                   </p>
                </div>
              </dd>
              <dd class="field-control">
                <ul class="notice-text-list">
                    <li class="notice-text">
                        본인은 LG유플러스가 다음과 같이 개인정보를 제3자에게 제공하는 것에 동의합니다.
                    </li>
                    <li class="input-container">                    
                        <input
                                id="agreement-offer-pop-confirm"
                                v-model="offerPopAgrYn"
                                type="checkbox"
                                name="agreement-offer-pop-confirm"
                                class="input-checkbox input-text"
                                title=""
                                ref="ref_offerPopConfirm"/>
                        <label
                                for="agreement-offer-pop-confirm"
                                class="input-label"
                        ><em class="primary-text">동의(필수)</em></label>
                    </li>
                </ul>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="dialog__footer">
        <button @click="confirmDialog" type="button" class="primary-button">
          확인
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'DisneyAgreePopup',
  data() {
      return{
        disneyPopAgrYn:false,
        offerPopAgrYn:false,
      }
  },

  created() {
  },
  methods: {

    /**
       * Function    : openAlert
       * Description : 기본 alert 호출 함수
       **/
      openAlert(title, message, ref) {
        this.$modal.show('dialog', {
          text: message,
          title: title,
          buttons: [
            {
              title: '확인',
              class: 'primary-button',
              handler: () => {
                if (ref) {
                  ref.focus()
                }
                this.$modal.hide('dialog')
              }
            }
          ]
        })
      },

    /** 
     * Function    : closeDialog
     * Description : Dialog 닫기
     **/
    closeDialog() {
      
      if (this.disneyPopAgrYn == true && this.offerPopAgrYn == true){         
          this.$store.state.isConfirm = true
          this.$emit('close', {
          id: 'ok',
          ok: 'Y'
        })
      }       
      this.$modal.hide('disneyAgree')
    },

    beforeClose() { 
      if(!this.$store.state.isConfirm) {
        this.$emit('close', {
          id: 'fail',
          ok: 'N'
        })
      }
      this.$store.state.isConfirm = false
    },

    /** 
     * Function    : confirmDialog
     * Description : 확인 클릭 시 이벤트 함수
     **/
    confirmDialog() {
      
      let title = '디즈니+ 월정액 가입신청 동의안내'
      let altMsg = ''

       /* [ST][CSR:C20211110_82139_4482139] 신규부가서비스(디즈니)반영요청건 2021.11.15 박지숙  */
       let dsineyAgrYn = 'X'
        if (this.disneyPopAgrYn == true && this.offerPopAgrYn == true){
          dsineyAgrYn = 'Y'
        }else if (!this.disneyPopAgrYn && !this.offerPopAgrYn){
          dsineyAgrYn = 'N'
        }else {
          if (!this.disneyPopAgrYn) {
            altMsg = '상품내용 관련 동의여부를 확인해주세요.'
          }else {
            altMsg = '개인정보 3자 제공에 대한 동의 여부를 확인해주세요.'
          }
        }       
        
        if (dsineyAgrYn === 'X') {
          this.openAlert(
                  title,
                  altMsg,
                  this.disneyPopAgrYn == false ? this.$refs.ref_disneyPopConfirm : this.$refs.ref_offerPopConfirm
          )
          return false
        } 
        /* [ED]][CSR:C20211110_82139_4482139] 신규부가서비스(디즈니)반영요청건 2021.11.15 박지숙 */

      this.$store.state.isConfirm = true
      this.$emit('close', {
        id: 'ok',
        ok: dsineyAgrYn
      })
      this.$modal.hide('disneyAgree')
    },
  }
}
</script>

<style scoped></style>
